import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, SimpleListAdapter, TS_Checkbox, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import { arrayToMap, dbObjectToId, Filter, filterInstances, sortArray } from '@nu-art/ts-common';
import './Editors.scss';
import { ICONS } from '@app/styles';
import { QScrollWrapper } from '../../../q-components/index.js';
import { convertValueDBToUI, valueType_EnumElement } from '@app/hcs-shared/core';
import { ModuleFE_Value, } from '../../../../_entity.js';
export class CompoundEnumeratedEditor extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        if (!nextProps.value.data) {
            nextProps.value.data = { scope: [], props: {}, subsetIds: [], subsets: [] };
        }
        const allValues = ModuleFE_Value.cache.all();
        const valuesMap = arrayToMap(allValues, dbObjectToId);
        state.enumeratedValues = (allValues.filter(item => item.type === valueType_EnumElement)).map(item => convertValueDBToUI(item, {
            values: valuesMap,
            measurementUnits: {}
        }));
        return state;
    }
    // ######################## Logic ########################
    addNewInnerValue = (valueStr) => {
        if (!valueStr)
            return;
        //Don't add a value that already exists
        if (this.props.value.data.scope.find(item => item.data.value === valueStr))
            return;
        const value = {
            type: valueType_EnumElement,
            data: {
                value: valueStr,
            }
        };
        this.props.value.data.scope.push(value);
        this.forceUpdate();
    };
    addExistingInnerValue = (innerValue) => {
        if (!innerValue)
            return;
        this.props.value.data.scope.push(innerValue);
        this.forceUpdate();
    };
    removeInnerValue = (innerValue) => {
        this.props.value.data.scope = this.props.value.data.scope.filter(item => item !== innerValue);
        this.forceUpdate();
    };
    // ######################## Render ########################
    renderInnerValues = () => {
        const innerValueIds = filterInstances(this.props.value.data?.scope.map(item => item._id)) || [];
        const innerValues = sortArray(this.props.value.data.scope, item => item._id ? 0 : 1);
        const values = this.state.enumeratedValues.filter(item => !innerValueIds.includes(item._id));
        const listAdapter = SimpleListAdapter(values, props => _jsx("div", { className: 'node-data', children: props.item.data.value }));
        const filter = new Filter(item => [item.data.value]);
        return _jsxs(LL_V_L, { className: 'dialog__main__section-item values', children: [_jsx("div", { className: 'dialog__field-title', children: "Inner Values" }), _jsx(QScrollWrapper, { flex: true, children: _jsxs(LL_H_C, { className: 'inner-values', children: [sortArray(innerValues, value => value.data?.value).map(value => {
                                const className = _className('inner-value', value._id ? 'existing' : undefined);
                                return _jsxs("div", { className: className, children: [_jsx(Button, { variant: 'tertiary', onClick: () => this.removeInnerValue(value), children: _jsx(ICONS.x.component, {}) }), _jsx("span", { children: value.data.value })] }, value.data.value);
                            }), _jsx(TS_DropDown, { selected: undefined, tabIndex: 0, onSelected: this.addExistingInnerValue, placeholder: 'Select Value', filter: filter, boundingParentSelector: '.dialog__main', noOptionsRenderer: 'Press Enter to create new value', onNoMatchingSelectionForString: this.addNewInnerValue, adapter: listAdapter })] }) })] });
    };
    renderAttributes = () => {
        const attributes = this.props.value.data.props;
        return _jsxs(LL_V_L, { className: 'dialog__main__section-item', children: [_jsx("div", { className: 'dialog__field-title', children: "Attributes" }), _jsxs(LL_H_C, { className: 'checkbox-container', children: [_jsx(TS_Checkbox, { checked: attributes.isExclusive, onCheck: () => {
                                attributes.isExclusive = !attributes.isExclusive;
                                this.forceUpdate();
                            } }), _jsx("span", { children: "Exclusive" })] }), _jsxs(LL_H_C, { className: 'checkbox-container', children: [_jsx(TS_Checkbox, { checked: attributes.isOrdered, onCheck: () => {
                                attributes.isOrdered = !attributes.isOrdered;
                                this.forceUpdate();
                            } }), _jsx("span", { children: "Ordered" })] })] });
    };
    render() {
        return _jsxs("div", { className: 'enumerated-editor', children: [_jsx(LL_V_L, { className: 'dialog__main__section', children: this.renderAttributes() }), _jsx(LL_V_L, { className: 'dialog__main__section', children: this.renderInnerValues() })] });
    }
}
//# sourceMappingURL=CompoundEnumeratedEditor.js.map